<template>
  <v-app>
    <v-app-bar class="subpages-header" app>
      <v-toolbar-title>
        <a href="/">
          <img src="/signherologoW.svg" class="hidden-xs-only signhero-logo" height="50"/>
          <img src="/SHicon.svg" class="hidden-sm-and-up signhero-icon" height="50"/>
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn color="white" text class="shio-language-button" :ripple="false" @click="showLanguageSetting">
            <v-icon>
              mdi-earth
            </v-icon>
            <span class="hidden-sm-and-down">&nbsp;{{ $t( 'message.ThisLocale' ) }}</span>
          </v-btn>
        </template>
      </v-menu>
    </v-app-bar>
    <v-main app>
      <div class="text-left" v-html="page_content" v-if="!choose_language_setting"></div>
      <v-row v-if="choose_language_setting" class="fill-height" no-gutters>
        <v-col>
          <div class="ma-auto mt-1 maxWidth-1100 pa-6">
            <h1 class="shio-section-title text-left">{{ $t( 'message.Locales' ) }}</h1>
            <v-radio-group v-model="locale" class="mx-3 mt-6">
              <v-radio v-for="locale in locales" :key="locale" :label="$t( 'message.locale!' + locale )" :value="locale"></v-radio>
            </v-radio-group>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <div class="text-left mt-2 mx-3">
                  <v-btn class="primary-btn choose-language-btn" @click="setLocale( locale )">{{ $t( 'signflow.Ok' ) }}</v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-main>
    <div>
      <v-footer class="subpages-footer" padless absolute>
        <v-col cols="12">
          <span class="mx-3">
            © {{ new Date().getFullYear() }} <a href="https://www.avaintec.com" target="_blank" rel="noopener">
            <strong>{{ $t( 'message.CompanyOyName' ) }}</strong></a>
          </span>
          <a class="mx-3" href="/privacy-policy.html#gmail">{{ $t( 'message.PrivacyPolicy' ) }}</a>
        </v-col>
      </v-footer>
    </div>
  </v-app>
</template>

<script>
    import util from "../../util/util";

    const locales = [ "en", "fi", "sv", "pl", "de", "nl", "fr", "es", "ro", "th" ];
    export default {
        name : "gmail-card",
        props : {
            contentPath : String,
        },
        data()
        {
            let locale;
            return {
                path : "/gmail-intro.html",
                page_content : require( "raw-loader!../../docs/homepage/"
                                        + (locale || util.getLocale())
                                        + this.contentPath ).default,
                curLocale : locale || util.getLocale(),
                locales : locales,
                choose_language_setting : false,
                locale : util.getLocale(),
            }
        },
        methods : {
            setLocale( newLoc )
            {
                util.setLocale( newLoc );
            },
            showLanguageSetting()
            {
              this.locale = util.getLocale();
              this.choose_language_setting = !this.choose_language_setting;
            }
        },
        mounted()
        {
          document.documentElement.setAttribute( 'lang', util.getLocale() );
        }
    }
</script>

<style lang="sass">
  @import "../../styles/style"
</style>
